import { Form } from "react-bootstrap";
import { ColumnType } from "../../app/models/components/columnType";
import { getValue } from "../../services/object/getValue";
import { useMemo } from "react";

interface Props<T> {
    item: T;
    column: ColumnType;
    columnIndex?: number;
    enableRowSelection?: boolean;
    isRowSelectable?: boolean;
    onRowSelect?: (item: T, isSelected: boolean) => void;
    isSelected?: boolean;
}

const TableRowCell = <T,>({ item, column, columnIndex, enableRowSelection, isRowSelectable = true, onRowSelect, isSelected }: Props<T>) => {
    const value = getValue(item, column.key);

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onRowSelect?.(item, event.target.checked);
    };

    const content = useMemo(() => {
        if (column.render) {
            return column.render(value, item);
        }
        if (value != null) {
            return `${value}`;
        }
        return "";
    }, [value, column, item]);

    if (enableRowSelection && columnIndex === 0) {
        return (
            <>
                <td className="sticky-column">
                    <Form.Check
                        type="checkbox"
                        id={`checkbox-${value}`}
                        onChange={handleCheckboxChange}
                        checked={isSelected ?? false}
                        disabled={!isRowSelectable}
                        className="sticky-column-checkbox"
                    />
                </td>
                <td>{content}</td>
            </>
        );
    }

    return <td>{content}</td>;
};

export default TableRowCell;
